import { gql } from '@apollo/client';

const wmsNoUpdateDetailContentFields = `
    id
    trackingNumber
    bagNumber
    orderId
    hubId
    hubName
    sortingCode
    noUpdateType
    noUpdateLocationType
    noUpdateLocationId
    noUpdateLocationName
    noUpdateHoursBucket
    responsibleHubName
    responsibleWarehouseName
    lastTrackingEventName
    lastTrackingAccountName
    lastTrackingAccountRole
    lastTrackingTime
    noUpdateStartEventName
    noUpdateStartAccountName
    noUpdateStartAccountRole
    noUpdateStartTime
    noUpdateEndTime
    noUpdateHours
    isCurrentlyNoUpdate
    isCausedPenalty
    statDate
    calculatedAt
    parcelStatus
    dspName
    driverName
    routeName
    responsibleSiteName
`;

// 注：WmsNoUpdateQueryFilterInput 新增 noUpdateStartTimeStart/End（Instant scalar，可空）
// 由于本项目 GraphQL Schema 由后端 graphql-kotlin 注解自动生成，前端 query 不需要显式声明字段，
// 只通过 variables 透传给后端 input 对象即可（与现有 noUpdateHoursBuckets 等字段同模式）。

export const QUERY_WMS_NO_UPDATE_DETAIL_LIST = gql`
    query QueryWmsNoUpdateDetailList($input: WmsNoUpdateDetailPageRequestInput!) {
        queryWmsNoUpdateDetailList(input: $input) {
            content {
                ${wmsNoUpdateDetailContentFields}
            }
            page
            size
            totalElements
            totalPages
            accessiblePages
            hasNext
            hasPrevious
        }
    }
`;

export const QUERY_WMS_NO_UPDATE_LOCATION_OPTIONS = gql`
    query QueryWmsNoUpdateLocationOptions($input: WmsNoUpdateLocationOptionsInput!) {
        queryWmsNoUpdateLocationOptions(input: $input) {
            id
            name
            type
        }
    }
`;
